const getPermission = (currentUser, businessFunctionName) => {
	const permission = currentUser && currentUser.permissions && currentUser.permissions.find(p => p.name.toLowerCase() === businessFunctionName.toLowerCase());
	return permission;
};

const hasPermission = (currentUser, businessFunctionName) => {
	const permission = getPermission(currentUser, businessFunctionName);
	return permission !== null && permission !== undefined;
}

const hasReadOnlyPermission = (currentUser, businessFunctionName) => {
	const permission = getPermission(currentUser, businessFunctionName);
	return permission && permission.isReadOnly;
};

export default {
	getPermission,
	hasPermission,
	hasReadOnlyPermission
};